// Staff.js
// Displays staff bios for Director, Class Teachers, and Specials
// Includes a modal dialog for expanded teacher bios
// Accessible: supports keyboard navigation, ARIA roles, and escape-to-close


import React, { useRef, useState } from "react";

import "./Staff.css";
import { useEffect } from "react";  

// Import images
import directorPhoto from "../assets/teachers/buckley.webp";
import salazar from "../assets/teachers/salazar.webp";
import schultz from "../assets/teachers/schultz.webp";
import gude from "../assets/teachers/gude.webp";
import vanwert from "../assets/teachers/vanwert.webp";
import leonard from "../assets/teachers/leonard.webp";
import benedict from "../assets/teachers/benedict.jpeg";
import musicTeacher from "../assets/teachers/morris.webp";
// import PETeacher from "../assets/teachers/peTeacher.png";
// import comingSoon from "../assets/teachers/comingSoon2.webp";
import joshi from "../assets/teachers/joshi.webp";


function Staff() {
  const [selectedTeacher, setSelectedTeacher] = useState(null);


    // --- Director profile (single object) ---
  const director = {
    name: "Kim Buckley",
    title: "Director",
    image: directorPhoto,
    description: `Mrs. Buckley first came to Binkley Preschool in 2008 as the parent of a two-year-old daughter — and it was love at first sight! She began her journey as a substitute teacher before spending six wonderful years as an assistant to two fabulous teachers in the four-year-old class. In 2016, Kim stepped into the role of director and considers her time at Binkley, and with her beloved Binkley family, to be one of the greatest joys of her life.

She feels deeply honored and privileged to lead such an extraordinary community — one that truly feels like her second home. A graduate of the University of San Francisco, Mrs. Buckley lives in Chapel Hill with her husband of 34 years, where they raised four children — two daughters and two sons.

`,
  };

  // --- Class data (grouped by class name) ---
  const classes = {
    "2 Year Olds Class": [
      {
        name: "Mrs. Salazar",
        title: "Teacher",
        image: salazar,
        description: `Nidia Salazar is originally from Costa Rica. She moved to NC in 2015 to work as a Dual Language Teacher in Chatham County Schools. 

She has a degree in Early Childhood Education from Universidad de Costa Rica and has experience with children 0 to 7 years old, but the preschool levels are her favorites. 

Nidia first came to Binkley in 2022 as a parent of a 2 year old and joined the team in 2024. She lives in Chapel Hill with her husband and son. 

Nidia enjoys watching soccer games, cooking, and traveling in her free time.

`,
      },
      {
        name: "Mrs. Schultz",
        title: "Teacher",
        image: schultz,
        description: `Jessica is joining Binkley Preschool as a co-teacher in the Manatees classroom. She fell in love with the school when she sent her eldest son to Binkley in 2024, and couldn't be happier to be a part of the team! Her youngest son will be a Binkley student this year as well. 
        
        Jessica received a BA in Elementary Education from The College of New Jersey and has served in many roles as an educator, including first grade teacher, kindergarten teacher, and instructional assistant. 
        
        She grew up in New Jersey, but is currently living in Chapel Hill with her husband, two sons, and dog (a corgi named Winnie!). In her free time she enjoys reading, Zumba, puzzles, and exploring new places with her family.`,
      },
    ],
    "3 Year Olds Class": [
      {
        name: "Mrs. Gude",
        title: "Teacher",
        image: gude,
        description: `Chloe Gude received her bachelor’s degree in education from Appalachian State University. She has taught private violin and public orchestra programs in various settings since 2008. 

        She enjoys working with both groups and individual students. Chloe quickly fell in love with Binkley when her daughter joined the Froggies class and was thrilled to join the Binkley teaching team a year later. 

        Originally from Burlington, Chloe has called Carrboro home since 2010. In addition to playing violin in local classical groups, she spends as much of her free time as possible outside birding and learning about the world around her.`,
      },
      {
        name: "Mrs. Joshi",
        title: "Teacher",
        image: joshi,
        description: `After previously serving as a substitute teacher, Kristin Joshi is delighted to officially join the Binkley community as both an educator and parent, supporting the care and growth of the children. Kristin is thoughtful, dedicated, and organized, and she looks forward to working alongside Mrs. Gude while learning from both her colleagues and the children each day.

Prior to staying home with her three children, Kristin worked as a registered nurse in pediatric and NICU settings. She enjoys reading picture books, spending time outdoors, and traveling abroad when possible. With both her mother and husband having immigrated to the United States, she deeply appreciates Binkley’s history and commitment to supporting families from a wide range of backgrounds. Kristin looks forward to getting to know more Binkley families in the coming weeks and warmly welcomes questions or connections.`,
      },
    ],
    "4 Year Olds Class": [
      {
        name: "Mrs. Van Wert",
        title: "Teacher",
        image: vanwert,
        description: `Dana earned her bachelor’s of science degree in psychology from UNC Charlotte. Her background is in neurological research with over ten years of experience focusing on behavioral health, specifically ADHD and addiction. 

        Before becoming the assistant teacher, Dana served as the parent board chair. She grew up in Charlotte and currently lives in Chapel Hill with her family. 

        Dana is an artist and enjoys finding the beauty of science in art. In her free time, she enjoys visiting the mountains and exploring the triangle with her family.`,
      },
      {
        name: "Mrs. Leonard",
        title: "Teacher",
        image: leonard,
        description: `Mrs. Leonard is updating her bio. Check back in a bit! :)`,
      },
    ],
  };

  const specials = {
  Music: [
    {
      name: "Mrs. Morris",
      title: "Music Teacher",
      image: musicTeacher,
      description: "Check back in a bit!",
    },
  ],
  PE: [
    {
      name: "Mrs. Benedict",
      title: "PE Teacher",
      image: benedict,
      description: `Jody Benedict has called Binkley Preschool her work home for 13+ years having recently returned following six years in the Chapel Hill-Carrboro Schools as an inclusion facilitator. 

      She completed a Masters Degree in Recreation Therapy from UNC-CH and has focused most of her work experience in preschool education and special needs. 

      Jody believes that play is powerfully important for self-discovery and social-emotional development. Jody lives with her husband in Chapel Hill where she grew up as a Tarheel, and enjoys hiking, being on the water, and time with her two children.`,
    },
  ],
};


useEffect(() => {
  if (selectedTeacher) {
    document.body.classList.add("modal-open");
    closeButtonRef.current?.focus();
  } else {
    document.body.classList.remove("modal-open");
  }
}, [selectedTeacher]);

  

    // Close modal and reset state

  const handleCloseBio = () => { 
    setSelectedTeacher(null); 
  }

  const closeButtonRef = useRef(null);


  return (
    <div className="staff-page">
      <h1 className="staff-title">Meet Our Staff</h1>

      {/* Director Section */}
      <div className="staff-card director">
        <img src={director.image} alt={director.name} className="staff-image" />
        <div className="staff-text">
          <h2>{director.name}</h2>
          <h3>{director.title}</h3>
          {director.description.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </div>

      {/* Classes Sections */}
      {Object.entries(classes).map(([className, teachers]) => (
        <div key={className} className="class-grid">
          <h2 className="staff-subtitle">{className}</h2>
          <div className="teacher-grid">
            {teachers.map((teacher, i) => (
              <div
              key={i}
              className="teacher-card"
            >
                <img 
                  src={teacher.image} 
                  alt={`Portrait of ${teacher.name}`}
                  loading="lazy" 
                />
                <h3>{teacher.name}</h3>
                <h4>{teacher.title}</h4>
                <button className="bio-button" onClick={() => setSelectedTeacher(teacher)}>Teacher Bio</button>
              </div>
            ))}
          </div>
        </div>
      ))}


      {/* Specials Section */}
<div className="class-grid">
  <h2 className="staff-subtitle">Specials</h2>

  <div className="specials-grid">
    {Object.entries(specials).map(([specialName, teachers]) => (
      <div key={specialName}>
        <h3 className="specials-subtitle">{specialName}</h3>

        <div className="teacher-grid">
          {teachers.map((teacher, i) => (
            <div
              key={i}
              className="teacher-card"

              tabIndex={0}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                setSelectedTeacher(teacher)
              }
            >
              <img src={teacher.image} alt={teacher.name} loading="lazy" />
              <h3>{teacher.name}</h3>
              <h4>{teacher.title}</h4>
              <button
                className="bio-button"
                onClick={() => setSelectedTeacher(teacher)}
              >
                Teacher Bio
              </button>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
</div>



      {/* Modal for bios */}
      {selectedTeacher && (
  <div
    className="staff-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="staff-modal-title"
    onClick={handleCloseBio}
    onKeyDown={(e) => e.key === "Escape" && handleCloseBio()}
  >
    <div className="staff-modal-content" onClick={(e) => e.stopPropagation()}>
      <span
  ref={closeButtonRef}
  className="close-button"
  role="button"
  tabIndex={0}
  aria-label="Close bio"
  onClick={handleCloseBio}
  onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleCloseBio()}
>
  &times;
</span>

      <img src={selectedTeacher.image} alt={selectedTeacher.name} />
      <div className="staff-modal-text">
        <h3 id="staff-modal-title">{selectedTeacher.name}</h3>
        <h4>{selectedTeacher.title}</h4>
        {selectedTeacher.description.split("\n\n").map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>
    </div>
  </div>
)}

  </div>
  );
}

export default Staff;
